import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	height: 100px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 10px;
	background: rgba(0, 0, 0, 0.2);
	overflow: hidden;
	padding: 10px 15px;
`;

export const Icon = styled.img`
	margin-right: 20px;
	margin-bottom: 10px;
	width: ${({ width }) => width};
`;

export const Text = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Title = styled.div`
	margin-bottom: 5px;
	font-weight: 700;
	font-size: 12px;
	line-height: 14px;
	display: flex;
	align-items: center;
	color: #ffffff;
`;

export const Description = styled.div`
	font-weight: 400;
	font-size: 11px;
	line-height: 13px;
	display: flex;
	align-items: center;
	color: #ffffff;
`;

export const Choose = styled.div`
	margin-top: 20px;
	font-weight: 600;
	font-size: 18px;
	line-height: 21px;
	display: flex;
	align-items: center;
	text-align: center;
	flex-direction: column;
	color: #ffffff;
`;

export const Arrow = styled.img`
	margin-right: 20px;
	margin-bottom: 10px;
	width: ${({ width }) => width};
`;
